var module = angular.module('octopusApp.configuration');

module.controller('TeamTestController', function($scope, busy, $q, octopusRepository) {
  var isLoading = $scope.isLoading = busy.create();

  $scope.filter = {
    selectedUser: ""
  };

  var promises = $q.all([
    octopusRepository.Users.all(),
    octopusRepository.Projects.all(),
    octopusRepository.Environments.all(),
    octopusRepository.PermissionDescriptions.all(),
    octopusRepository.Tenants ? octopusRepository.Tenants.all() : $q.resolve([]),
    octopusRepository.ProjectGroups.all()

  ]);

  isLoading.promise(promises.then(function (results) {
    $scope.users = results[0];
    $scope.projects = _.indexBy(results[1], "Id");
    $scope.environments = _.indexBy(results[2], "Id");
    $scope.permissionInfo = results[3];
    $scope.tenants = _.indexBy(results[4], "Id");
    $scope.projectGroups = _.indexBy(results[5], "Id");
  }));

  $scope.test = function() {
    var user = _.find($scope.users, function (u) { return u.Id === $scope.filter.selectedUser.Id; });
    $scope.user = user;

    isLoading.promise(octopusRepository.Users.getPermissions(user).then(function (results) {
      $scope.exportUrl = octopusRepository.resolve(results.Links["Export"]);
      $scope.teams = results.Teams;
      $scope.permissions = [];

      var grantedPermissions = _.chain(results.Permissions).map(function (a,b) { return { perms: a, name: b }; }).indexBy("name").value();
      _.each($scope.permissionInfo, function(p, k) {
        if (grantedPermissions[k]) {
          _.each(grantedPermissions[k].perms, function (perm) {
            $scope.permissions.push({ name: k, perms: perm, info: p });
          });
        }
      });

      $scope.permissions = _.sortBy($scope.permissions, "name");

      var prev = "";
      _.each($scope.permissions, function (p) {
        if (prev === p.name) {
          p.sameAsPrevious = true;
        } else {
          p.sameAsPrevious = false;
        }
        prev = p.name;
      });
    }));
  };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/configuration/teams/controllers/team_test_controller.js
// module id = 406
// module chunks = 1